import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { VisitableClassesMap } from "./visitables";
var getNodeType = function getNodeType(node) {
  var nodeClass = node.constructor;
  var nodeType = VisitableClassesMap.get(nodeClass);
  if (!nodeType) {
    throw new Error("\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 visitable \u043F\u0440\u0438 \u043F\u0440\u043E\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0438 \u0434\u0435\u0440\u0435\u0432\u0430: ".concat(nodeClass.name));
  }
  return nodeType;
};
export var VisitorPath = /*#__PURE__*/function () {
  function VisitorPath(node, params, parent) {
    _classCallCheck(this, VisitorPath);
    this.node = node;
    this.params = params;
    this.parent = parent;
    _defineProperty(this, "_nodeType", void 0);
    _defineProperty(this, "depth", void 0);
    this.depth = parent ? parent.depth + 1 : 0;
  }
  _createClass(VisitorPath, [{
    key: "nodeType",
    get: function get() {
      if (!this._nodeType) this._nodeType = getNodeType(this.node);
      return this._nodeType;
    }
  }]);
  return VisitorPath;
}();